/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_time_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A leap second is an occasional extra second added to clock time to keep it aligned with the Earth's slightly irregular rotation — unrelated to leap years. It affects official atomic-clock timekeeping, not everyday duration conversions like the ones here, which assume a constant 86,400 seconds per day.`)
};

const es_uc_time_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un segundo intercalado es un segundo adicional ocasional agregado al tiempo de reloj para mantenerlo alineado con la rotación ligeramente irregular de la Tierra — no está relacionado con años bisiestos. Afecta la sincronización oficial de reloj atómico, no las conversiones de duración cotidiana como las aquí, que asumen una constante 86,400 segundos por día.`)
};

const de_uc_time_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Schaltsekunde ist eine gelegentlich zusätzliche Sekunde, die der Uhrzeit hinzugefügt wird, um sie mit der leicht unregelmäßigen Erdrotation in Einklang zu halten — unabhängig von Schaltjahren. Sie betrifft die offizielle Zeitmessung mit Atomuhren, nicht alltägliche Dauerumrechnungen wie die hier, die von konstanten 86,400 Sekunden pro Tag ausgehen.`)
};

const nl_uc_time_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een schrikkelseconde is een occasionele extra seconde aan kloktijd toegevoegd om deze met de iets onregelmatige rotatie van de Aarde te houden — niet gerelateerd aan schrikkeljaren. Het beïnvloedt officiële atoomkloktijdhouding, niet alledaagse duur conversies zoals hier, welke van een constante 86.400 seconden per dag uitgaan.`)
};

const fr_uc_time_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une seconde intercalaire est une seconde supplémentaire occasionnelle ajoutée au temps de l'horloge pour la maintenir alignée avec la rotation légèrement irrégulière de la Terre — sans rapport avec les années bissextiles. Elle affecte l'horloge atomique officielle, pas les conversions de durée quotidienne comme celles ici, qui supposent une constante 86 400 secondes par jour.`)
};

const it_uc_time_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un secondo intercalare è un secondo extra occasionalmente aggiunto al tempo dell'orologio per mantenerlo allineato con la rotazione leggermente irregolare della Terra — non correlato agli anni bisestili. Influisce sulla cronologia atomica ufficiale, non le conversioni di durata quotidiane come quelle qui, che presuppongono un costante 86.400 secondi al giorno.`)
};

const pt_br2_uc_time_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um segundo bissexto é um segundo extra ocasional adicionado ao tempo do relógio para mantê-lo alinhado com a rotação ligeiramente irregular da Terra — desvinculado de anos bissextos. Afeta cronometragem de relógio atômico oficial, não conversões de duração cotidiana como as aqui, que assumem um constante 86.400 segundos por dia.`)
};

const pt_uc_time_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um segundo bissexto é um segundo extra ocasional adicionado ao tempo do relógio para mantê-lo alinhado com a rotação ligeiramente irregular da Terra — não relacionado a anos bissextos. Afecta o cronometragem oficial do relógio atómico, não conversões de duração do dia a dia como as aqui, que assumem um constante 86400 segundos por dia.`)
};

const ja_uc_time_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`うるう秒は、地球のわずかに不規則な回転に合わせた時間を保つために、クロック時間に追加される時折の追加秒で — うるう年とは関係がありません。それはオフィシャルなアトミッククロック時間計測に影響しますが、ここのような日常の継続時間変換には影響しません。それは1日あたり一定の86,400秒を想定しています。`)
};

const zh_uc_time_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_time_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_time_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_time_faq3_a", locale)
	if (locale === "en") return en_uc_time_faq3_a(inputs)
	if (locale === "es") return es_uc_time_faq3_a(inputs)
	if (locale === "de") return de_uc_time_faq3_a(inputs)
	if (locale === "nl") return nl_uc_time_faq3_a(inputs)
	if (locale === "fr") return fr_uc_time_faq3_a(inputs)
	if (locale === "it") return it_uc_time_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_time_faq3_a(inputs)
	if (locale === "pt") return pt_uc_time_faq3_a(inputs)
	if (locale === "ja") return ja_uc_time_faq3_a(inputs)
	return zh_uc_time_faq3_a(inputs)
};